<template>
  <el-dialog v-model="visible" class="small no-header no-padding" @close="visible = false" :append-to-body="true">
    <div class="desc">
      <p>{{ $t(props.authType === 'bind' ? 'Please use wechat to scan the QR code and follow the official account binding' : 'Please scan the QR code using WeChat') }}</p>
    </div>
    <div class="qrcode" v-loading="loading" element-loading-background="transparent">
      <img :src="qrcodeSrc" :class="{ hide: !qrcodeSrc }" alt="qrcode" />
    </div>
    <slot/>
  </el-dialog>
</template>

<script setup>
import { getWeChatBinding, getWeChatBindingRes } from '@/api/user/user';
import { ElMessage } from 'element-plus';
import { computed, getCurrentInstance, ref } from 'vue';

const { $t } = getCurrentInstance().proxy

const emits = defineEmits(['on-success'])
const props = defineProps({
  // 授权类型：auth(仅授权，比如删除账号前)/bind(绑定账号)
  authType: {
    type: String,
    default: 'bind'
  }
})

const visible = defineModel(false)

/**
 * 授权微信账号
 */
const open = () => {
  visible.value = true
  if (!qrcodeTicket.value || qrcodeIsExpired.value) {
    handleRefreshQrcode()
  } else {
    handleCheckBindResult()
  }
}

const loading = ref(false)
const qrcodeTicket = ref('')
const qrcodeIsExpired = ref(false)
const qrcodeSrc = computed(() => qrcodeTicket.value ? `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${qrcodeTicket.value}` : '')
let qrcodeExpiredTimer = null
// 获取二维码信息
const handleRefreshQrcode = async () => {
  if (loading.value) return
  loading.value = true
  try {
    const { data } = await getWeChatBinding({ type: props.authType })
    qrcodeTicket.value = data.ticket
    qrcodeIsExpired.value = false
    if (qrcodeExpiredTimer) clearTimeout(qrcodeExpiredTimer)
    qrcodeExpiredTimer = setTimeout(() => {
      qrcodeIsExpired.value = true
    }, data.expire * 1000)
    setTimeout(() => {
      handleCheckBindResult()
    }, 1000)
  } catch (error) {
    console.log(error)
  }
  loading.value = false
}

// 检测绑定状态
const handleCheckBindResult = async () => {
  try {
    await getWeChatBindingRes(qrcodeTicket.value, { type: props.authType })
    if (qrcodeExpiredTimer) clearTimeout(qrcodeExpiredTimer)
    visible.value = false
    qrcodeIsExpired.value = true
    emits('on-success')
  } catch (err) {
    if (err.code === 2012) {
      ElMessage.error($t('http_error_2012'))
      handleRefreshQrcode()
    } else if (!qrcodeIsExpired.value && visible.value) {
      setTimeout(() => {
        handleCheckBindResult()
      }, 1000)
    }
  }
}

defineExpose({
  open
})
</script>

<style lang="scss" scoped>
.desc {
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 48px;
  padding: 0 56px;
}
.qrcode {
  width: 80%;
  margin: 32px auto 0;
  display: flex;
  justify-content: center;
  img {
    width: 172px;
    height: 172px;
    &.hide {
      opacity: 0;
    }
  }
}

</style>